import React from "react";
import LoginStepBtn from "../../components/loginStepBtn/loginStepBtn.component";
import LoginPhoneFirstStep from "../../containerSmall/loginPhoneFirstStep/loginPhoneFirstStep.component";
import LoginPhoneLastStep from "../../containerSmall/loginPhoneLastStep/loginPhoneLastStep.component";
// import LoginPhoneSecondStep from "../../containerSmall/loginPhoneSecondStep/loginPhoneSecondStep.component";
import { LoginPhoneStyled } from "./loginPhone.styles";

const LoginPhone = ({ loginStep }) => {
  return (
    <LoginPhoneStyled loginStep={loginStep} className="shadow">
      {loginStep < 2 && <LoginPhoneFirstStep />}
      {loginStep === 2 && <LoginPhoneLastStep />}

      {/* <LoginPhoneSecondStep /> */}
      <LoginStepBtn />
    </LoginPhoneStyled>
  );
};

export default LoginPhone;
